/**
 * The active Quote Log entry linked to a SPARTA job (#34126, Req 2 of #30672),
 * surfaced as the "View linked Quote" deep link on the timekeeping job view.
 * Mirrors the C# UPS.Sparta.DTO.EmployeePortal.LinkedQuoteDto. PascalCase, the
 * same casing the sibling Sparta job-readiness DTO uses (the Sparta API
 * negotiates response casing and both services request PascalCase).
 */
export interface LinkedQuoteDto {
  /** The linked Quote Log entry's GUID. The deep-link target. */
  QuoteLogId: string;
  /** The RFQ number, used as the human-readable link label. May be empty. */
  RFQNumber: string;
}
